<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12>
          <p class="mb-2 bold">{{ adresa.jmeno }} {{ adresa.prijmeni }}</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <p class="mx-2 mb-0" v-if="adresa.typ_osoby=='po'">{{ adresa.nazev_firmy }}</p>
          <p class="mx-2 mb-0" v-if="adresa.typ_osoby=='po'||adresa.typ_osoby=='osvc'">IČ: <span v-if="adresa.ic!=null&&adresa.ic.length>0">{{ adresa.ic }}</span><span v-else>--</span>, DIČ: <span v-if="adresa.dic!=null&&adresa.dic.length>0">{{ adresa.dic }}</span><span v-else>--</span></p>
          <p class="mx-2 mb-0">Tel.: <span v-if="adresa.telefon!=null&&adresa.telefon.length>0">{{ adresa.telefon }}</span><span v-else>--</span></p>
        </v-flex>
        <v-flex xs12 sm6>
          <p class="mx-2 mb-0"><span v-if="adresa.ulice!=null&&adresa.ulice.length>0">{{ adresa.ulice }}</span><span v-else>Ulice: --</span></p>
          <p class="mx-2 mb-0"><span v-if="adresa.mesto!=null&&adresa.mesto.length>0">{{ adresa.mesto }}</span><span v-else>Město: --</span></p>
          <p class="mx-2 mb-0"><span v-if="adresa.psc!=null&&adresa.psc.length>0">{{ adresa.psc }}</span><span v-else>PSČ: --</span></p>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    adresa: Object
  }
}
</script>
